<div class="analytics-disabled-message">
  <div class="message-card">
    <!-- Icon with animated background -->
    <div class="icon-wrapper">
      <div class="icon-pulse"></div>
      <i class="pi pi-chart-line"></i>
    </div>

    <!-- Main Content -->
    <div class="content-wrapper">
      <h3>New Revenue Analytics Are Coming to Your Site</h3>
      <p class="subtitle">
        Get powerful insights into your subscription and non-subscription
        revenue
      </p>

      <!-- Benefits List -->
      <div class="benefits-grid">
        <div class="benefit-item">
          <i class="pi pi-check-circle"></i>
          <span>Track revenue trends over time</span>
        </div>
        <div class="benefit-item">
          <i class="pi pi-check-circle"></i>
          <span>Compare subscription vs. non-subscription</span>
        </div>
        <div class="benefit-item">
          <i class="pi pi-check-circle"></i>
          <span>Monitor order volumes & AOV metrics</span>
        </div>
        <div class="benefit-item">
          <i class="pi pi-check-circle"></i>
          <span>Export data for deeper analysis</span>
        </div>
      </div>

      <!-- Preview using ACTUAL Revenue Cards -->
      <div class="preview-revenue-cards">
        <app-revenue-card
          *ngFor="let card of mockRevenueCards"
          [data]="card"
          class="preview-card-wrapper"
        />
      </div>

      <!-- Call to Action -->
      <div class="cta-buttons">
        <button class="primary-cta" (click)="openSupportBeacon()" type="button">
          <i class="pi pi-comments"></i>
          <span>Contact Support to Enable</span>
        </button>
      </div>
    </div>
  </div>
</div>
